import * as React from 'react';
import { SVGProps } from 'react';

const SvgEngraved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.22266 11.702L17.9278 5.72607L27.0039 11.0793L16.3064 17.0586L7.22266 11.702Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M16.3047 32.2682L27.0132 26.2898V11.0703L16.3048 17.042L16.3047 32.2682Z'
      fill='#D9D9D9'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M16.3047 31.8581L27.0132 25.8797V11.0784L16.3048 17.0501L16.3047 31.8581Z'
      fill='#FFDECC'
      stroke='#FF4D00'
      strokeLinejoin='round'
    />
    <path
      d='M16.3047 20.9993L27.0136 15.0234L29.9436 16.7154L19.2314 22.6897L16.3047 20.9993Z'
      fill='#FFDECC'
      stroke='#FF4D00'
      strokeLinejoin='round'
    />
    <path
      d='M22.0828 20.3879V35.6117L7.20898 27.4125V11.8715L10.2786 13.4944L13.2943 15.3139L16.3021 17.0505V20.9979L19.0487 22.5586L19.2281 18.8085L22.0828 20.3879Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M22.084 35.6121L32.7925 29.6338V14.4143L22.0841 20.386L22.084 35.6121Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M19.1543 18.6964L29.8632 12.7205L32.7932 14.4125L22.081 20.3867L19.1543 18.6964Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M29.8828 12.7122L19.1516 18.6961V22.6364L16.2969 20.9993V17.0423L27.0074 11.074'
      stroke='#FF4D00'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.3047 17.0501L27.0131 11.0784'
      stroke='#FF4D00'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgEngraved;
